export default {
  LAW: [
    'Adoption Law',
    'Antitrust Law',
    'Appellate Law',
    'Arbitration & Mediation',
    'Aviation, Admiralty, Maritime, and Transportation',
    'Banking & Financial',
    'Bankrupty & Workout',
    'Business Law',
    'Civil Law - Litigation',
    'Civil Law - Transactional',
    'Commercial Litigation',
    'Construction',
    'Consumer Debt',
    'Corporate Counsel',
    'Corporate Finance / Mergers & Acquisitions',
    'Criminal Defense',
    'Education',
    'Elder Law',
    'Eminent Domain',
    'Family Law',
    'General Practice',
    'Government & Administrative',
    'Health Care Law',
    'Immigration Law',
    'Insurance',
    'Intellectual Property Rights',
    'International Law',
    'Labor & Employment',
    'Land Use & Environment',
    'Non-Profit - Attorneys for',
    'Oil and Gas',
    'Product Liability',
    'Professional Malpractice (Non-Medical) Defense',
    'Real Estate',
    'Securities Law',
    'Sexual Abuse',
    'Sports Law',
    'Tax Law',
    'Technology / Virtual',
    'Traffic Law',
    'Wills, Trusts, & Estates',
    'Worker\'s Compensation',
  ],
};
